import { render, staticRenderFns } from "./PanelPaywall.vue?vue&type=template&id=8c74ff92&scoped=true&"
import script from "./PanelPaywall.vue?vue&type=script&lang=js&"
export * from "./PanelPaywall.vue?vue&type=script&lang=js&"
import style0 from "./PanelPaywall.vue?vue&type=style&index=0&id=8c74ff92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c74ff92",
  null
  
)

export default component.exports